import React from "react";
import CheckInModal from "./CheckInModal";

const CheckOutModal = (props) => {
  return <CheckInModal type="check-out" {...props} />;
};

export default CheckOutModal;
